import React from 'react'
import MediaQuery from 'react-responsive'
import Logotipo from '../../images/monefica.svg'
import * as S from './styles'

const trackClickBuilder = (url) => {
	window.location = url;
}

export function Header({ theme }) {
	const trackClick = trackClickBuilder

	return (<S.Header bgColor={theme.palette.primary.main}>
		<S.Container maxWidth={theme.config.containerWidth}>
			<S.Logotipo src={Logotipo} alt="Monefica" title="Monefica"/>
			<MediaQuery query="(min-width: 1024px)">
			<div style={{display: 'flex', flexDirection:'row'}}>
				<S.NavItem onClick={()=> trackClick("https://monefica.com.br")}>HOME</S.NavItem>
				<S.NavItem onClick={()=> trackClick("https://planejador.monefica.com.br")}>PLANEJADOR DE IMPOSTO DE RENDA</S.NavItem>
				<S.NavItem onClick={()=> trackClick("https://monefica.com.br/sobre-nos")}>SOBRE NÓS</S.NavItem>
				<S.NavItem onClick={()=> trackClick("https://monefica.com.br/blog/")}>BLOG</S.NavItem>
				<S.NavItem onClick={()=> trackClick("https://monefica.com.br/contato")}>CONTATO</S.NavItem>
			</div>
				</MediaQuery>
		</S.Container>
	</S.Header>)
}
